<template>
    <div class="d-flex box-cover display-box"
         :class="contentClass">
        <template v-if="cardContent">
            <div class="card w-100 h-100 p-1">
                <slot></slot>
            </div>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>

<script>
import {isNeedCleanApp} from "@/utils/mobileUtil";

export default {
    name: "AppContent",
    props: {
        flexColumn: {
            type: Boolean,
            default: false
        },
        cardContent: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        isCleanMode() {
            return isNeedCleanApp(window.location.pathname);
        },
        contentClass() {
            let tempList = [];
            tempList.push(this.flexColumn ? 'flex-column' : 'flex-row');
            if (!this.isCleanMode) {
                tempList.push('app-content shrink');
            }
            return tempList.join(" ");
        },
    },
}
</script>

<style scoped>
.box-cover {
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
}

.shrink {
    padding-top: 62px;
}
</style>
